import React from 'react';
import { motion } from 'framer-motion';
import { Landmark, Pill, GraduationCap, Building2, ShoppingBag, Radio } from 'lucide-react';
import PageHeader from './PageHeader';
import SpotlightCard from './SpotlightCard';
import './Results.css';

const Results = () => {
  const sectors = [
    { label: 'Bancos', icon: Landmark },
    { label: 'Farmácias', icon: Pill },
    { label: 'Prefeituras', icon: Building2 },
    { label: 'Escolas', icon: GraduationCap },
    { label: 'Grandes Empresas de Telecom', icon: Radio },
    { label: 'Shoppings', icon: ShoppingBag }
  ];

  return (
    <>
      <PageHeader
        title="Setores que Atendemos"
        subtitle="Infraestrutura de TI para diferentes segmentos em todo o Brasil."
        breadcrumb="Resultados"
      />

      <section className="results section">
        <div className="container">
          {/* Setores Atendidos */}
          <div className="results-sectors">
            <p className="stat-description mb-8">
              Nossa infraestrutura de TI dá suporte a instituições financeiras, redes de farmácias,
              prefeituras, escolas, grandes empresas de telecomunicações e shopping centers em todo o Brasil.
            </p>
            <div className="stats-grid">
              {sectors.map((sector, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <SpotlightCard className="h-full" spotlightColor="rgba(220, 38, 38, 0.05)">
                    <div className="stat-card-inner">
                      <div className="stat-icon-wrapper">
                        <sector.icon size={24} />
                      </div>
                      <div className="stat-label">{sector.label}</div>
                    </div>
                  </SpotlightCard>
                </motion.div>
              ))}
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Results;

